
import {
  BoundingPosition,
  CoordinatesPosition,
  DesktopRoomObject,
  Room,
  RoomObject,
  User,
  UserRoomStateData,
} from '@/utils/models';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import UserIcon from './users/UserIcon.vue';
import RoomObjectDisplayer from './image-or-video-displayer/RoomObjectDisplayer.vue';

@Component({
  components: { UserIcon, RoomObjectDisplayer },
})
export default class RoomMap extends Vue {
  @Prop() room!: Room;
  @Prop() user!: User;
  @Prop() participants!: UserRoomStateData[];
  @Prop() objects!: RoomObject[];
  @Prop() currentSubRoomId!: string;
  @Prop() roomScale!: number;
  @Prop() scale!: number;
  @Prop() shareScreens!: DesktopRoomObject[];
  @Prop() userPosition!: CoordinatesPosition;
  @Prop() userParticipantData!: UserRoomStateData | undefined;
  @Prop() connecting!: boolean;
  @Prop() hideImage?: boolean;
  @Prop() enteredRoomObject?: RoomObject | DesktopRoomObject;
  @Prop() activeShareScreenUserIds!: Set<string>;

  @Emit() loadedImagePositionChange(args: { newPosition: CoordinatesPosition; roomObject: RoomObject }) {}
  @Emit() changeSize(args: { newSize: BoundingPosition; roomObject: RoomObject }) {}

  @Emit() shareScreenChangePosition(args: { newPosition: CoordinatesPosition; roomObject: RoomObject }) {}
  @Emit() shareScreenVideoSizeSet(args: { newSize: BoundingPosition; roomObject: RoomObject }): void {}
  @Emit() userIconPointerDown(ev: PointerEvent) {}
  @Emit() userIconPointerUp(ev: PointerEvent) {}
  @Emit() userIconDoubleClick(ev: MouseEvent) {}
  @Emit() removeMessage() {}
  @Emit() unmuteAudio() {}
  @Emit() remoteVideoMute(remote: UserRoomStateData) {}
  @Emit() requestSchedule(userId: string) {}
  @Emit() requestShowSchedule(remote: UserRoomStateData) {}
  @Emit() clickRemoteUser(ev: Event, stateData: UserRoomStateData) {}
  @Emit() toggleShowStatusSelector() {}
  @Emit() onPointerLeaveClearObject(roomObject: RoomObject | DesktopRoomObject) {}
  @Emit() onPointerEnterSetObject(ev: PointerEvent, roomObject: RoomObject | DesktopRoomObject) {}
  @Emit() onPointerMove() {}

  get loadedImages(): RoomObject[] {
    if (this.hideImage) {
      return this.objects.filter(
        (o) => o.objectType == 'image' || (o.objectType == 'board' && o.props.boardType !== 'iframe'),
      );
    }
    return this.objects.filter((o) => o.objectType == 'image' || o.objectType == 'board');
  }

  isSharingScreen(ursd: UserRoomStateData): boolean {
    return this.activeShareScreenUserIds.has(ursd.userState.userId);
  }
}
